// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"toDlPmlaDnJitbiAqA2g"};